import { Select } from '@iqueue/ui-kit'
import HelpersPresenter from '../../api/helpersPresenter'
import { useCallback } from 'react'
import { t } from '../../hooks/useTranslate'

export default function PickNodeType({
  name = 'type',
  value,
  hidden,
  ...props
}) {

  const nodeTypesHierarchy = ['ORGANIZATION', 'FACTORY', 'FIELD', 'COLLECTION_POINT', 'WELL']

  const render = useCallback((id) => {
    // const isDisabled = (value && nodeTypesHierarchy.indexOf(id) <= nodeTypesHierarchy.indexOf(value))

    return {
      id,
      title: t(`type.node.${ id }`),
      // disabled: isDisabled,
    }
  }, [t, value, nodeTypesHierarchy])

  return <Select
    hidden
    name={ name }
    entries={ nodeTypesHierarchy }
    render={ render }
    disabled={ value === 'ORGANIZATION' }
    value={ value }
    { ...props }
  />
}
